import React, { useEffect, useState } from "react";

export function isVideoMedia(src = "", type = "auto") {
  if (type === "video") return true;
  if (type === "image") return false;
  const value = String(src || "").toLowerCase();
  return (
    /\.(mp4|webm|mov|m4v|m3u8)(\?|#|$)/.test(value) ||
    value.includes("/video/upload/")
  );
}

export default function MediaRenderer({
  src,
  type = "auto",
  fallback = "",
  alt = "",
  className = "",
  videoClassName = "",
  imageClassName = "",
  placeholderClassName = "",
  background = false,
  controls = false,
  preload = "metadata",
}) {
  const [failed, setFailed] = useState(false);
  const mediaSrc = failed ? fallback : src;
  const mediaType = failed && fallback ? "auto" : type;

  useEffect(() => {
    setFailed(false);
  }, [src, fallback]);

  if (!mediaSrc) {
    return (
      <div
        className={`grid place-items-center bg-zinc-900 text-sm text-gray-500 ${className} ${placeholderClassName}`}
      >
        Média indisponible
      </div>
    );
  }

  if (isVideoMedia(mediaSrc, mediaType)) {
    return (
      <video
        src={mediaSrc}
        className={`${className} ${videoClassName}`}
        autoPlay={background}
        muted={background}
        loop={background}
        playsInline
        controls={controls}
        preload={preload}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <img
      src={mediaSrc}
      alt={alt}
      className={`${className} ${imageClassName}`}
      onError={() => setFailed(true)}
    />
  );
}
